import React from "react";
import initialAppData from "./InitialAppDataContext.d";
const InitialAppData: initialAppData = {
	locations: []
};
export const InitialAppDataContext = React.createContext<initialAppData>(InitialAppData);
